import { COUNTRIES_BY_CODE, COUNTRY_CODES } from "@redotech/locale/countries";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { CustomerCountryState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/customer-country";
import { BadgeRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoTagsDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-tags-dropdown-input";
import { memo, useMemo, useState } from "react";

export const CustomerCountryDetails = memo(function CustomerCountryDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<CustomerCountryState>) {
  const [searchString, setSearchString] = useState("");

  const countryOptions: BadgeRedoListItem<string>[] = useMemo(() => {
    return COUNTRY_CODES.map((countryCode) => ({
      id: countryCode,
      value: countryCode,
      type: "badge" as const,
      badge: {
        text: COUNTRIES_BY_CODE[countryCode] || countryCode,
        color: "gray" as const,
      },
    }));
  }, []);

  const filteredOptions = useMemo(() => {
    if (!searchString) {
      return countryOptions;
    }
    const searchLower = searchString.toLowerCase();
    return countryOptions.filter((option) => {
      const text = option.badge.text;
      const id = option.id;
      return (
        (typeof text === "string" &&
          text.toLowerCase().includes(searchLower)) ||
        (typeof id === "string" && id.toLowerCase().includes(searchLower))
      );
    });
  }, [countryOptions, searchString]);

  const selectedCountries: BadgeRedoListItem<string>[] = useMemo(() => {
    return [...state].map((countryCode) => ({
      id: countryCode,
      value: countryCode,
      type: "badge" as const,
      badge: {
        text: COUNTRIES_BY_CODE[countryCode] || countryCode,
        color: "gray" as const,
      },
    }));
  }, [state]);

  return (
    <RedoTagsDropdownInput
      disabled={disabled}
      label="Countries"
      options={filteredOptions}
      placeholder="Select countries..."
      searchPlaceholder="Search countries..."
      searchString={searchString}
      selectedOptions={selectedCountries}
      setSearchString={setSearchString}
      setSelectedOptions={(items) => {
        setState(items.map((item) => item.value));
      }}
      size="xs"
    />
  );
});
